// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tree-structure-lite-main-ul {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.tree-structure-lite-main-ul > li {
  position: relative;
  display: block;
  cursor: pointer;
}
.tree-structure-lite-main-ul > li > div:hover {
  background: rgba(0, 0, 0, 0.2);
  font-weight: 700;
}
.tree-structure-lite-sub-ul {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
  line-height: initial;
}
.tree-structure-lite-sub-ul > li {
  position: relative;
  display: block;
  cursor: pointer;
}
.tree-structure-lite-sub-ul > li:last-child::after {
  height: 20px;
}
.tree-structure-lite-sub-ul > li:first-child::after {
  top: -10px;
}
.tree-structure-lite-sub-ul > li:only-child::after {
  top: -10px;
  height: 30px;
}
.tree-structure-lite-sub-ul > li > div:hover {
  background: rgba(0, 0, 0, 0.2);
  font-weight: 700;
}
.tree-structure-lite-sub-ul > li::before {
  background: #134459;
  bottom: auto;
  content: "";
  height: 8px;
  left: 6px;
  margin-top: 15px;
  position: absolute;
  right: auto;
  width: 8px;
  z-index: 1;
  border-radius: 50%;
}
.tree-structure-lite-sub-ul > li::after {
  border-left: 1px solid #134459;
  bottom: 0;
  content: "";
  left: 10px;
  position: absolute;
  top: 0;
}
.tree-structure-lite-icon-right {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tree-structure-lite-icon-right .expand-arrow {
  padding: 8px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
